import React from "react";
import { useNavigate } from 'react-router-dom';


const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="section_page_not_found">
      <h1 className="error">404</h1>
      <div className="my-8 text-[20px] font-semibold text-[#444444]">
        Ooops!!! The page you are looking for is not found
      </div>
      <button
        className="inline-block border-2 border-[#222] text-white uppercase font-semibold py-[0.75rem] pr-4 pb-[0.6rem] pl-4 transition-all duration-200 shadow-[0_15px_15px_-11px_rgba(0,0,0,0.4)] bg-[#222] rounded-[6px] hover:bg-[#222] hover:text-[#ddd]"
        onClick={() => navigate('/')}
      >
        Back to home
      </button>
    </div>
  );
};

export default NotFound;
